import React, { useState, useEffect } from 'react'
import Cookies from 'universal-cookie'
import { getBaseURL } from '../../URLs'
import DropDownList from './DropDownList'

export default (props) => {
    const [forms, setForms] = useState([])

    useEffect(() => {
        const cookies = new Cookies(document.cookie)
        let cacheKey = `formNames_${props.formType}_${cookies.get('CoRoot')}`
        if (props.assetType !== '' && props.serviceType !== '')
            cacheKey = `formNames_${props.assetType}_${props.serviceType}_${cookies.get('CoRoot')}`

        if (
            localStorage.getItem(cacheKey) &&
            localStorage.getItem(cacheKey) !== 'false' &&
            localStorage.getItem(cacheKey) !== 'null'
        ) {
            setForms(JSON.parse(localStorage.getItem(cacheKey)))
        } else {
            let url = `${getBaseURL()}webapi/form/types/${props.formType.toLowerCase()}}`
            if (props.assetType !== '' && props.serviceType !== '')
                url = `${getBaseURL()}webapi/form/types/${
                    props.assetType
                }/${props.serviceType.toLowerCase()}`

            fetch(url, {
                credentials: 'include',
            })
                .then((response) => {
                    return response.json()
                })
                .then((json) => {
                    setForms(json)
                })
        }
    }, [props.formType, props.serviceType, props.assetType])

    return (
        forms && (
            <DropDownList
                name={props.name}
                {...props}
                key={`${props.id}_ddlForms`}
                id={`${props.id}_ddlForms`}
                options={[
                    {
                        FormId: '',
                        Form: '-- Select One --',
                    },
                    ...forms,
                ].map((curForm) => (
                    <option
                        key={`formOp${curForm.FormId}`}
                        value={curForm.FormId}
                    >{`${curForm.Form.trim()}`}</option>
                ))}
            />
        )
    )
}
